import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-studentinfodetail',
  templateUrl: './studentinfodetail.component.html',
  styleUrls: ['./studentinfodetail.component.scss']
})
export class StudentinfodetailComponent implements OnInit {

  constructor( private meta: Meta,
               private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Alumni – Stay Connected and Grow Together');
        this.meta.updateTag({
            name: 'description',
            content: `Join the ARNI Alumni network to reconnect, share experiences, and access career opportunities. Stay engaged with your alma mater and contribute to its legacy.`
        });
    }

}
